// extracted by mini-css-extract-plugin
export default {"tier":"styles_tier__dds4i","tierTitle":"styles_tierTitle__SjLFQ","tierRate":"styles_tierRate__Q+rG4"};